export default "/site/aidive/js/react/dist/images/iris_logo.76f0c32e.png";